import { Col, Container, Row } from "react-bootstrap";
import React from "react";
import "./Footer.css";

export function Footer() {
  return (
    <Container className="footerContainer">
      <Row className="footer mt-5 p-5">
        <Col lg={2} md={0} />
        <Col lg={4} md={6}>
          <h3>Contact</h3>
          <address>
            <div>Home Konvent</div>
            <div>Hoveniersberg 24</div>
            <div>9000 Gent</div>
            <div>
              <a href="mailto:praeses@homekonvent.be">praeses@homekonvent.be</a>
            </div>
          </address>
        </Col>
        <Col lg={4} md={6}>
          <h3>Links</h3>
          <div>
            <a href="https://www.ugent.be/student/nl/meer-dan-studeren/huisvesting">
              Studentenhomes UGent
            </a>
          </div>
          <div>
            <a href="https://hogent.be/toekomstige-student/huisvesting/studentenhomes/">
              Studentenhomes HoGent
            </a>
          </div>
          <div>
            <a href="https://helpdesk.ugent.be">ICT Helpdesk UGent</a>
          </div>
          <div>
            <a href="https://vertrouwenspersoon.homekonvent.be/">
              Vertrouwenspersoon
            </a>
          </div>
          <div>
            <a href="https://swapshop.homekonvent.be/">Swapshop</a>
          </div>
          <div>
            <a href="https://www.arteveldehogeschool.be/">
              Arteveldehogeschool.be
            </a>
          </div>
          <div>
            <a href="https://www.ugent.be/">UGent.be</a>
          </div>
          <div>
            <a href="https://hogent.be/">HoGent.be</a>
          </div>
        </Col>
        <Col lg={2} md={0} />
      </Row>
    </Container>
  );
}
